export const pageRootSx = {
    width: '100%',
    height: '100%',
    p: { xs: 1, sm: 1.5 },
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
};

export const headerWrapperSx = { mb: 2 };

export const backLinkSx = {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    mb: 1,
    width: 'fit-content',
};

export const backIconSx = {
    verticalAlign: 'middle',
    transform: 'scaleX(1.3)',
    transformOrigin: 'center left',
    mr: 0.5,
};

export const titleSx = { letterSpacing: 0.4 };

export const contentPaperSx = {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    borderRadius: 2,
    overflow: 'hidden',
    flex: 1,
    minHeight: 0,
};

export const leftPaneSx = {
    flex: 1,
    p: { xs: 1, sm: 1.75 },
    minWidth: 0,
    overflowY: 'auto',
};

export const feedbackTypeLabelSx = { mb: 0.4, color: 'primary.main' };

export const feedbackTypeGroupSx = { gap: { xs: 0, sm: 1.25 }, flexWrap: 'wrap' };

export const feedbackTypeRadioSx = {
    color: 'success.main',
    p: 0.25,
    '&.Mui-checked': { color: 'success.main' },
};

export const subjectFieldSx = { mb: 1.1 };

export const editorWrapperSx = {
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    mb: 2,
    overflow: 'hidden',
    '& .ql-toolbar.ql-snow': {
        border: 'none',
        borderBottom: '1px solid',
        borderColor: 'divider',
        bgcolor: 'grey.50',
    },
    '& .ql-container.ql-snow': {
        border: 'none',
        minHeight: 130,
        fontFamily: 'inherit',
    },
    '& .ql-editor': {
        minHeight: 130,
        lineHeight: 1.6,
        fontSize: 16,
    },
    '& .ql-editor.ql-blank::before': {
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: 16,
        fontFamily: 'inherit',
        color: 'rgba(0, 0, 0, 0.42)',
    },
    '& .ql-editor ul, & .ql-editor ol': {
        paddingLeft: '1.5rem',
    },
    '& .ql-editor em, & .ql-editor i': {
        fontStyle: 'italic !important',
    },
};

export const attachButtonSx = {
    borderColor: 'success.main',
    color: 'success.main',
    textTransform: 'none',
    mb: 0.5,
    fontSize: '0.8rem',
    '&:hover': { borderColor: 'success.dark', bgcolor: 'success.50' },
};

export const fileRulesTextSx = { mb: 1 };

export const attachedFilesWrapSx = { mb: 1.5, display: 'flex', flexWrap: 'wrap', gap: 1 };

export const attachedFileChipSx = {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    bgcolor: 'grey.100',
    borderRadius: 1,
    px: 1,
    py: 0.25,
    fontSize: '0.75rem',
};

export const removeFileIconSx = { p: 0.25, ml: 0.25, fontSize: '0.65rem' };

export const submitButtonSx = {
    bgcolor: 'success.main',
    textTransform: 'none',
    px: 2.5,
    py: 0.5,
    fontSize: '0.8rem',
    '&:hover': { bgcolor: 'success.dark' },
};

export const rightPaneSx = {
    width: { xs: '100%', md: 280, lg: 310 },
    flexShrink: 0,
    p: { xs: 1, sm: 1.25 },
    bgcolor: 'transparent',
    alignSelf: 'stretch',
    display: 'flex',
};

export const rightPaneCardSx = {
    bgcolor: 'grey.100',
    borderRadius: 2.5,
    p: { xs: 1.25, sm: 1.5 },
    width: '100%',
    minHeight: { md: '100%' },
    overflowY: 'auto',
};

export const contactTitleSx = { fontSize: '0.82rem' };

export const contactItemSx = (idx: number, total: number) => ({
    mb: idx < total - 1 ? 2 : 0,
});

export const contactSubtitleSx = { mb: 0.45 };

export const contactRowSx = { display: 'flex', alignItems: 'center', gap: 0.5 };

export const contactEmailIconSx = { fontSize: 14, color: 'success.main' };

export const contactEmailLinkSx = {
    color: 'success.main',
    textDecoration: 'none',
    '&:hover': { textDecoration: 'underline' },
};
